module.exports = __webpack_public_path__ + "static/media/meta.0b27682c.svg";